// removed by extract-text-webpack-plugin
module.exports = {"Chat":"Message__Chat__25sJh","ChatRoom":"Message__ChatRoom__1eBXR","ChatBox":"Message__ChatBox__1Dts8","Msg":"Message__Msg__Pe2kI","SelfMsg":"Message__SelfMsg__3WRAS","MsgOwner":"Message__MsgOwner__2bPFB","MsgOwnerImage":"Message__MsgOwnerImage__3YsYg","SubmitBtn":"Message__SubmitBtn__3bNPY","MsgBody":"Message__MsgBody__3TdjK","MsgContent":"Message__MsgContent__2_l2o","Title":"Message__Title__1Wl7p","yurayura":"Message__yurayura__3MNj6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Message/Message.css
// module id = 326
// module chunks = 0